<template>
  <div id="posts-timeline">

    <transition name="fade">
      <RingLoader v-if="performingRequest" :color="this.spinnerColor" :size="this.spinnerSize"></RingLoader>
    </transition>

    <div>
      <!-- Feed of posts -->
      <div v-if="posts.length">
        <div id="timeline-title">{{ currentList.title }}</div>

        <div id="timeline-visualization"></div>

      </div><!-- /v-if -->

      <div v-else>
        <div class="card">
          <div class="card-body">
            <p class="card-text">There are currently no posts</p>
          </div><!-- /.card-body -->
        </div><!-- /.card -->
      </div>
    </div><!-- /.container -->
  </div><!-- /#posts-map -->
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment'
  import RingLoader from 'vue-spinner/src/RingLoader.vue'
  const fb = require('../firebaseConfig.js')

  export default {
    data() {
      return {
        performingRequest: true,
        spinnerColor: '#2674a3',
        spinnerSize: '50px'
      }
    },
    components: { RingLoader },
    computed: {
      ...mapState(['userProfile', 'currentUser', 'posts', 'currentList'])
    },
    created: function () {
      let self = this;

      if (self.$route.name == 'Visualization' && self.$route.params.mode == 'user') {
        let userData
        fb.usersCollection.doc(self.$route.params.id).get().then(res => {
          userData = res.data()
          self.$store.dispatch('setCurrentList', {title: userData.company})
          console.log(userData)
        }).catch(err => {
          console.log(err)
        })
      }

      setTimeout(function () {
        var datesArray = []
        // DOM element where the Timeline will be attached
        var container = document.getElementById('timeline-visualization');

        // Prepare the datesArray
        var i;
        for (i = 0; i < self.posts.length; i++) {
          let postItemId = i + 1;
          let postItemContent = self.posts[i].title
          let postItemStart = self.formatFullDate(self.posts[i].dates.start)
          let postItemEnd = self.formatFullDate(self.posts[i].dates.end)
          let postItemStartEndObj = {id: postItemId, content: postItemContent, start: postItemStart, end: postItemEnd}
          let postItemStartObj = {id: postItemId, content: postItemContent, start: postItemStart}

          if (self.posts[i].dates.start != null && self.posts[i].dates.end != null) {
            if (postItemStart === postItemEnd) {
              datesArray.push(postItemStartObj)
            } else {
              datesArray.push(postItemStartEndObj)
            }
          }

        }

        // Create a DataSet (allows two way data-binding)
        var items = new vis.DataSet(datesArray);

        // Configuration for the Timeline
        var options = {
          height: '100%'
        };

        // Create a Timeline
        var timeline = new vis.Timeline(container, items, options);
      }, 10)
      setTimeout(function() {
        self.performingRequest = false
      }, 2000)
    },
    methods: {
      formatFullDate(val) {
        if (!val) { return '-' }
        let date = val.toDate()
        let year = moment(date).year()
        let month = moment(date).month() + 1
        let day = moment(date).date()
        let completeDate = year + '/' + month + '/' + day
        return completeDate
      },
      formatFigure(value) {
        let val = (value/1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      openPostModal(post) {
        this.$emit('openPostModal', post)
      },
      formatDateSeconds(val) {
        if (!val) { return null }
        let date = val.toDate()
        return moment(date).unix()
      },
      getNow() {
        return moment().unix()
      }
    },
    filters: {
      formatDate(val) {
        if (!val) { return '-' }
        let date = val.toDate()
        return moment(date).fromNow()
      },
      trimLength(val) {
        if (val.length < 200) {
          let regex = /(<([^>]+)>)/ig;
          let cleanVal = val.replace(regex, " ");
          return cleanVal
         }
        let regex = /(<([^>]+)>)/ig;
        let cleanVal = val.replace(regex, " ");
        return `${cleanVal.substring(0, 200)}...`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PostsTimeline.vue